import React, { useRef } from "react";
import Icon from "sulu-admin-bundle/components/Icon";
import Toggler from "sulu-admin-bundle/components/Toggler/Toggler";

import { changeSecondsToString } from "../../hooks/useCountdown";
import CardDetails from "./CardDetails";
import GoalDetails from "./GoalDetails";
import PSPCDetails from "./PSPCDetails";
import Submit from "./HandleSubmit";

const handleDelete = (
    event,
    matchData,
    matchId,
    setMatchData,
    setEventsToShow,
    freezeEventDetails,
    updateStaffHandler,
    playerCardHandler,
) => {
    const { id } = event;

    const eventToDelete = matchData.matchPosts?.find(
        (match) => match.id === id,
    );

    if (!eventToDelete) {
        console.warn("Post to delete not found in match posts.");
        return;
    }

    const update = {
        matchPosts: matchData.matchPosts.map((post) => {
            if (eventToDelete?.id === post?.id) {
                return {
                    ...post,
                    isDeleted: true,
                };
            }
            return post;
        }),
    };
    setEventsToShow((data) => data.filter((item) => item.id !== id));

    Submit(matchId, matchData, update, setMatchData)
        .then((response) => {
            if (freezeEventDetails.current.playerSelected?.contactName) {
                updateStaffHandler &&
                    updateStaffHandler(
                        event.playerSelected,
                        event.sideSelected.side,
                        event.type.name,
                        freezeEventDetails,
                        true,
                        response?.allMatchStaff,
                    );
            } else {
                playerCardHandler &&
                    playerCardHandler(
                        event.sideSelected,
                        freezeEventDetails,
                        event,
                        event.type.name,
                        ["remove"],
                        response?.allMatchPlayers,
                    );
            }
        })
        .catch((e) => console.error(e.message));
};

const Header = ({
    setModalOpen,
    eventDetails,
    setEventDetails,
    goals,
    setGoals,
    isEditing,
    setEventsToShow,
    matchData,
    matchId,
    setMatchData,
    isShootout,
    pcEventActive,
    psEventActive,
    playerCardHandler,
    updateStaffHandler,
    // Replaces the default delete of the single post.
    onDelete,
}) => {
    const freezeEventDetails = useRef(eventDetails);
    const cancelEvent =
        isEditing && eventDetails?.type?.name === "GOAL"
            ? () => {
                  setEventDetails(freezeEventDetails?.current);
              }
            : !isEditing && eventDetails?.type?.name === "GOAL"
              ? () => {
                    if (!pcEventActive && !psEventActive) {
                        setGoals((data) => ({
                            ...data,
                            [eventDetails?.sideSelected?.side]:
                                data[eventDetails?.sideSelected?.side] - 1,
                        }));
                    }
                }
              : () => {};

    return (
        <>
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    backgroundColor:
                        eventDetails?.sideSelected?.teamColor || "#595959",
                    padding: "0 20px",
                }}
            >
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        width: "10%",
                        ...(!eventDetails?.sideSelected?.teamColor && {
                            color: "#fff",
                        }),
                    }}
                >
                    <p
                        style={{
                            fontWeight: "700",
                        }}
                    >
                        {changeSecondsToString(
                            "timeOfEvent",
                            eventDetails?.timestamp,
                        )}
                    </p>
                    <p
                        style={{
                            fontWeight: "700",
                            color: eventDetails?.sideSelected?.teamColor
                                ? "gray"
                                : "#fff",
                        }}
                    >
                        {eventDetails?.realPeriod}
                    </p>
                </div>

                {eventDetails?.type?.name === "PS" && (
                    <PSPCDetails eventDetails={eventDetails} text="PS" />
                )}
                {eventDetails?.type?.name === "PC" && (
                    <PSPCDetails eventDetails={eventDetails} text="PC" />
                )}

                {eventDetails?.type?.name === "GOAL" && !isShootout ? (
                    <GoalDetails eventDetails={eventDetails} />
                ) : null}

                {["GRÜN", "GELB", "ROT"].includes(eventDetails?.type?.name) && (
                    <CardDetails
                        eventDetails={eventDetails}
                        backgroundColor={eventDetails?.type?.background}
                    />
                )}

                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                    }}
                >
                    {setEventsToShow && (
                        <div
                            style={{
                                backgroundColor: "white",
                                padding: "3px 8px",
                                borderRadius: 20,
                                marginRight: 10,
                                display: "flex",
                                alignItems: "center",
                            }}
                        >
                            <span
                                style={{
                                    fontWeight: 700,
                                    marginRight: 10,
                                }}
                            >
                                Live
                            </span>
                            <Toggler
                                checked={eventDetails?.liveEvent}
                                onChange={() => {
                                    const originalEvent =
                                        matchData.matchPosts.find(
                                            (post) =>
                                                post.id === eventDetails.id,
                                        );
                                    if (originalEvent?.isLive === null) {
                                        originalEvent.isLive = true;
                                    }
                                    setEventDetails((data) => ({
                                        ...data,
                                        liveEvent: !data?.liveEvent,
                                    }));
                                    setEventsToShow((data) => {
                                        return [
                                            ...data?.map((item) => {
                                                if (
                                                    item?.id ===
                                                    eventDetails?.id
                                                ) {
                                                    return {
                                                        ...item,
                                                        liveEvent:
                                                            !item?.liveEvent,
                                                        isChanged:
                                                            originalEvent.isLive !==
                                                            !item.liveEvent,
                                                    };
                                                }
                                                return item;
                                            }),
                                        ];
                                    });
                                }}
                            />
                        </div>
                    )}

                    {matchData && eventDetails?.id && (
                        <button
                            style={{
                                backgroundColor: "white",
                                height: 30,
                                width: 30,
                                borderRadius: "50%",
                                border: "none",
                                cursor: "pointer",
                            }}
                            onClick={() => {
                                onDelete
                                    ? onDelete()
                                    : handleDelete(
                                          eventDetails,
                                          matchData,
                                          matchId,
                                          setMatchData,
                                          setEventsToShow,
                                          freezeEventDetails,
                                          updateStaffHandler,
                                          playerCardHandler,
                                      );
                                cancelEvent(); // this to cancel the event type === "GOAL" and not add it to list ie. only works for adding a new event not when editing
                                setModalOpen(false);
                            }}
                        >
                            <Icon name="su-trash-alt" />
                        </button>
                    )}
                    <button
                        style={{
                            backgroundColor: "white",
                            height: 30,
                            width: 30,
                            marginLeft: "10px",
                            borderRadius: "50%",
                            border: "none",
                            cursor: "pointer",
                        }}
                        onClick={() => {
                            cancelEvent(); // this to cancel the event type === "GOAL" and not add it to list ie. only works for adding a new event not when editing
                            setModalOpen(false);
                        }}
                    >
                        <Icon name="su-times" />
                    </button>
                </div>
            </div>
        </>
    );
};

export default Header;
